import User from '@mui/icons-material/Person';
import React from 'react';
const BotAvatar = () => {
    return (React.createElement(User, { style: {
            fontSize: '30px',
            marginTop: '8px',
        } }));
};
export default BotAvatar;
